import { createRequestReducer } from "redux-request-state";

import * as actions from "./kanban.actions";

export const kanban = createRequestReducer({
    begin: actions.REQUEST_KANBAN,
    success: actions.RECEIVE_KANBAN,
    failure: actions.ERROR_KANBAN
});